import * as prismic from '@prismicio/client'
import { getRuntimeConfigValue } from './runtimeConfig'

// -- Prismic API endpoint
// Determines which repository to query and fetch data from
export const apiEndpoint =  'https://gcc-ab-jb-bca.cdn.prismic.io/api/v2'

const {
  PRISMIC_ACCESS_TOKEN: envPrismicAccessToken,
} = process.env;

const PRISMIC_ACCESS_TOKEN = getRuntimeConfigValue('PRISMIC_ACCESS_TOKEN', envPrismicAccessToken);

// -- Link resolution rules
// Manages the url links to internal Prismic documents
export const linkResolver = (doc) => {
  if (doc.type === 'page') return `/${doc.uid}`
  if (doc.type === 'gcc_home_page') return `/${doc.uid}`
  if (doc.type === 'gcc_content_page') return `/${doc.uid}`
  if (doc.type === 'gcc_blog_entry') return `/blog/${doc.uid}`
  return '/'
}

// Client method to query documents from the Prismic repo.
export const client = prismic.createClient(apiEndpoint, {
  accessToken: PRISMIC_ACCESS_TOKEN || undefined,
})